<template>
  <div style="width: 100%; height: 100%; position: fixed; left:0; background-color:rgba(40,40,40,0.3);z-index:999999">
    <div
      :class="computedClass"
      class="offline-message"
      color="warning"
    >
      {{ msg }}
    </div>
    <div style="width: 100%">
      <v-progress-linear
        indeterminate
        color="rgba(215, 2, 2, 0.5)"
        background-color="rgba(220, 2, 2, 0.5)"
      ></v-progress-linear>
    </div>
    <slot :name="slotName" />
  </div>
</template>

<script>
export default {
  name: "Offline",
  props: {
    slotName: {
      type: String,
      required: false,
      default: "online"
    },
    onlineClass: {
      type: String,
      required: false,
      default: ""
    },
    offlineClass: {
      type: String,
      required: false,
      default: ""
    }
  },
  data: () => ({
    isOnline: true,
    msg:
      "Keine Internetverbindung. Bitte überprüfen Sie \n Ihre Verbindung und versuchen es erneut."
  }),
  computed: {
    computedClass() {
      return this.isOnline ? this.onlineClass : this.offlineClass;
    }
  }
};
</script>

<style>
.offline-message {
  background: #f58686;
  padding: 0px 20px 0 20px;
  text-align: center;
  height: 40px;
  width: 100%;
  font-weight: bold;
  font-size: 0.8rem;
  color: white;
}
</style>
